import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
  state: {

  },
  getters: {

  },
  actions: {
    sendContacto: ({
      commit
    }, data) => {
      console.log(data);
      return new Promise((resolve, reject) => {
        axios.post('https://back.carretilla.info/api/save', data)
          .then(result => {
            resolve(result.data)

          }).catch(error => {
            reject(false);
          });
      });
    }
  },
  mutations: {

  }
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js